import request from '@/utils/request';

const DEPOSIT_OPTIONS_TIMEOUT_MS = 30000;

/** TopPay 本地法币充值能力（由后端 regions 返回可用地区） */
export function getTopPaySupported(acceptLanguage) {
  return request.get('/liyuan-evm-pm/pm-chain/toppay/onramp/supported', undefined, {
    timeout: DEPOSIT_OPTIONS_TIMEOUT_MS,
    ...(acceptLanguage ? { headers: { 'Accept-Language': acceptLanguage } } : {}),
  });
}

/** 创建 TopPay 充值订单。本地法币页应带 payMoney（通道收款额）。 */
export function createTopPayOnrampOrder(data = {}) {
  return request.post('/liyuan-evm-pm/pm-chain/toppay/onramp/orders', data);
}

/** 分页查询 TopPay 充值订单 */
export function getTopPayOnrampOrders(params = {}) {
  return request.get('/liyuan-evm-pm/pm-chain/toppay/onramp/orders', params);
}
